import {
  Autocomplete,
  Checkbox,
  Grid,
  InputLabel,
  List,
  ListItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Chip,
  CircularProgress,
  Tooltip,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import InputFields from 'routes/Pages/components/InputFields/InputFields';
import { checklistCompletedOption, speciesOptions, yesNoOption } from '../Data/HFDropDowdData';
import { forwardingMaintanceVehicalCheckListoptionList } from '../Data/HfInputFieldsData';
import SectionAccordians from 'routes/Pages/components/Accordians/SectionAccordians';
import DetailedM3Table, { calcTotals, isTonnesUom } from './DetailedM3Table';
import { DropzoneUpload } from './InputsRendered';
import { Box } from '@material-ui/core';
import { EmployeeNameField } from 'routes/Pages/GenTask/components/SharedFormFields';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';
const dropDownStyles = {
  paddingBottom: '10px',
  fontSize: '0.825rem',
  color: 'black',
};
const autoCompleteSlotProps = {
  paper: {
    sx: {
      '& .MuiAutocomplete-option': {
        fontSize: '0.82rem',
        fontWeight: 500,
      },
    },
  },
};
const HFDailyForwardingCloseForm = ({
  curForwardingData,
  setCurrForwardinggData,
  spList,
  spListObj,
  currentForwardingMaintenanceCheckListData,
  setCurrentForwardingMaintenanceCheckListData,
  productionData,
  setProductionData,
  setNewUploadedFiles,
  files,
  isLoading,
  handleFileChange,
  handleDeleteFiles,
  viewFile,
  machineList,
}) => {

  const uom = curForwardingData['unitOfMeasure'] || 'M3';
    const isTonnes = isTonnesUom(uom);
  
    const { totalValue, totalM3 } = React.useMemo(
      () => calcTotals(productionData, uom),
      [productionData, uom]
    );
  
    useEffect(() => {
      setCurrForwardinggData(prev => ({
        ...prev,
        totalValue: isTonnes && totalValue ? Number(totalValue.toFixed(2)) : totalM3,
        total_M3: totalM3 ? Number(totalM3.toFixed(2)) : '',
      }));
    }, [totalValue, totalM3, isTonnes, setCurrForwardinggData]);

  const extractionMachineOptions = React.useMemo(() => {
    return machineList.find(group => group.keyName === 'ExtractionMachine')?.values || [];
  }, [machineList]);

  const handleChangeForwardingData = (name, value) => {
    let updatedData = {
      [name]: value,
    };
    if (name === 'overnightStay') {
      if (value === 'No') {
        updatedData['fullNameAccommodation'] = '';
      }
    }
    setCurrForwardinggData(prevData => ({
      ...prevData,
      ...updatedData,
    }));
  };
  const handleForwardingMachineChecklistChange = (name, value) => {
    setCurrentForwardingMaintenanceCheckListData(prevData => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [fixedProducts, setFixedProducts] = useState([]);

  // Fetch products whenever WH / Forest SP Number changes
  useEffect(() => {
    const forestSPName = curForwardingData['forestSPNumber'];
    const contractUniqueID = spListObj?.[forestSPName]?.contractUniqueID;

    if (!contractUniqueID) {
      setFixedProducts([]);
      return;
    }

    const fetchProducts = async () => {
      try {
        const res = await customAxios.get(`/Ops/GetContractProductDestinations/${contractUniqueID}`, {
          headers: authHeader(),
        });

        const productList = Array.from(
          new Set((res?.data || []).filter(item => item.productGroup).map(item => item.productGroup.trim())),
        );

        setFixedProducts(productList);
      } catch (err) {
        console.log('Error fetching WH products:', err);
        setFixedProducts([]);
      }
    };

    fetchProducts();
  }, [curForwardingData['forestSPNumber'], spListObj]);

  // Merge fetched products into productionData as default rows
  useEffect(() => {
    if (!fixedProducts || fixedProducts.length === 0) return;

    setProductionData(prevData => {
      const existingNames = new Set(prevData.map(row => row.productName));
      const newRows = fixedProducts
        .filter(name => !existingNames.has(name))
        .map((name, idx) => ({
          productNo: `${prevData.length + idx + 1}`,
          productName: name,
          m3: '',
          notes: '',
        }));

      if (newRows.length === 0) return prevData;
      return [...prevData, ...newRows];
    });
  }, [fixedProducts]);

  return (
    <Grid
      container
      spacing={1}
      sx={{
        '& .MuiTableCell-root': {
          fontSize: '0.825rem',
        },
        '& .MuiInputBase-root': {
          fontSize: '0.825rem !important',
        },
        paddingBottom: '1rem',
      }}>
      <EmployeeNameField value={curForwardingData['employeeName']} onChange={handleChangeForwardingData} isOperator />

      <InputFields
        label="Date & Time"
        helperText={'Enter Clock in Date & Time'}
        name="date_Time"
        required={true}
        value={curForwardingData['date_Time']}
        textFieldType={'datetime-local'}
        width={4}
        handleIpChange={handleChangeForwardingData}
      />
      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Was their tops left to one side for the forwarder?
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'wasTheirTopsLeftToOneSideForTheForwarder'}
          value={curForwardingData['wasTheirTopsLeftToOneSideForTheForwarder'] || null}
          options={yesNoOption}
          onChange={(event, newValue) => handleChangeForwardingData('wasTheirTopsLeftToOneSideForTheForwarder', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>

      {curForwardingData['wasTheirTopsLeftToOneSideForTheForwarder'] === 'No' && (
        <InputFields
          label="State Why?"
          name="wasTheirTopsLeftToOneSideForTheForwarderReason"
          required={curForwardingData['wasTheirTopsLeftToOneSideForTheForwarder'] == 'No'}
          value={curForwardingData['wasTheirTopsLeftToOneSideForTheForwarderReason']}
          textFieldType={'text'}
          multiline={true}
          width={12}
          handleIpChange={handleChangeForwardingData}
        />
      )}

      <Grid item xs={6} sm={6} md={6}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Machine
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'machine'}
          value={curForwardingData['machine'] || null}
          options={extractionMachineOptions}
          onChange={(event, newValue) => handleChangeForwardingData('machine', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} sx={{ alignContent: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexDirection: 'row-reverse' }}>
          <Typography variant="subtitle2">
            Subsistence Tracking(Tick Box if you were away from base for less than 10 hours )
          </Typography>
          <Checkbox
            checked={curForwardingData['subsistenceTracking'] || false}
            onChange={e => handleChangeForwardingData('subsistenceTracking', e.target.checked)}
          />
        </div>
      </Grid>

      <InputFields
        label="Non Productive Hours"
        name="nonProductiveHours"
        value={curForwardingData['nonProductiveHours']}
        textFieldType={'number'}
        width={4}
        handleIpChange={handleChangeForwardingData}
      />

      <InputFields
        label="Reason For Non Productive Hours"
        helperText={'This must be preapproved with your manager'}
        name="reasonForNonProductiveHours"
        value={curForwardingData['reasonForNonProductiveHours']}
        textFieldType={'text'}
        width={4}
        handleIpChange={handleChangeForwardingData}
        multiline={true}
      />

      <InputFields
        label="Manager Approved Downtime"
        name="managerApprovedDowntime"
        value={curForwardingData['managerApprovedDowntime']}
        textFieldType={'text'}
        width={4}
        handleIpChange={handleChangeForwardingData}
      />

      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles}>
          Site Bonus %
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'siteBonus'}
          value={curForwardingData['siteBonus'] ?? null}
          options={[0, 25, 50, 75, 100]}
          getOptionLabel={option => `${option}`}
          onChange={(event, newValue) => handleChangeForwardingData('siteBonus', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>

      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles}>
          Machine Bonus %
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'machineBonus'}
          value={curForwardingData['machineBonus'] ?? null}
          options={[0, 25, 50, 75, 100]}
          getOptionLabel={option => `${option}`}
          onChange={(event, newValue) => handleChangeForwardingData('machineBonus', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>

      <InputFields
        label="Manager Feedback"
        name="managerFeedback"
        value={curForwardingData['managerFeedback']}
        textFieldType={'text'}
        width={12}
        handleIpChange={handleChangeForwardingData}
        multiline={true}
      />

      <Grid item xs={12} sm={12} md={4} sx={{ alignContent: 'end' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexDirection: 'row-reverse' }}>
          <Typography variant="subtitle2">
            Moved location for signal ?(Tick if you needed to move location to get cellular signal)
          </Typography>
          <Checkbox
            checked={curForwardingData['movedLocationForSignal'] || false}
            onChange={e => handleChangeForwardingData('movedLocationForSignal', e.target.checked)}
          />
        </div>
      </Grid>
      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Forest or SP Number
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'forestSPNumber'}
          value={curForwardingData['forestSPNumber'] || null}
          options={spListObj ? Object.keys(spListObj) : []}
          onChange={(event, newValue) => handleChangeForwardingData('forestSPNumber', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>
      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Species
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'species'}
          value={curForwardingData['species'] || null}
          options={speciesOptions}
          onChange={(event, newValue) => handleChangeForwardingData('species', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        <SectionAccordians header={'Forwarding Maintenance Checklist & Instructions'}>
          <Typography variant="subtitle1">
            Daily Maintenance Every 10 Hours for Harvester/Forwarder Engine Separate Engine Owners Manual
          </Typography>

          <List>
            <ListItem>1.Check oil and liquid leaks repair if necessary</ListItem>
            <ListItem>2.Check any intake and exhaust air leaks</ListItem>
            <ListItem>3.Check the engine or level</ListItem>
          </List>
          <Typography variant="subtitle1">Bogies</Typography>
          <List>
            <ListItem>1.Check any leaks</ListItem>
          </List>
          <Typography variant="subtitle1">Hydraulic System</Typography>
          <List>
            <ListItem>1.Check any leaks</ListItem>
          </List>
          <Typography variant="subtitle1">Greasing</Typography>
          <List>
            <ListItem>1.Check any faultless operation of the lubrication system</ListItem>
            <ListItem>2.Grease grab/crane and centre section every 10 hours</ListItem>
          </List>
        </SectionAccordians>
      </Grid>
      <Grid item xs={6} sm={6} md={12}>
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: '10px', // Rounded corners
            overflow: 'hidden', // Ensures children don’t overflow borderRadius
            boxShadow: 1, // Optional: adds a shadow
          }}>
          <Table border={1} size="small" sx={{ border: '1px solid #ccc', fontSize: '0.825rem' }}>
            <TableHead>
              <TableRow>
                <TableCell width="70%"></TableCell>
                <TableCell>Choose Completed or No Completed</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {forwardingMaintanceVehicalCheckListoptionList.map((item, index) => {
                return (
                  <TableRow key={`${index}_${item.label}`}>
                    <TableCell>{item.label}</TableCell>
                    <TableCell>
                      <Autocomplete
                        size="small"
                        disablePortal
                        name={item.key}
                        value={currentForwardingMaintenanceCheckListData[item.key] || null}
                        options={checklistCompletedOption}
                        onChange={(event, newValue) => handleForwardingMachineChecklistChange(item.key, newValue)}
                        sx={{ fontSize: '0.8rem' }}
                        renderInput={params => <TextField {...params} size="small" fullWidth />}
                        fullWidth
                        slotProps={{
                          ...autoCompleteSlotProps,
                        }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      {/* Detailed Table for M3 / Tonnes */}
      <Grid item xs={12} sm={12} md={12}>
        <DetailedM3Table
          productionData={productionData}
          setProductionData={setProductionData}
          currDailyHarvestingData={curForwardingData}
          handleChangeDailyHarvestingData={handleChangeForwardingData}
        />
      </Grid>

      {isTonnes && (
        <InputFields
          label="Total Value"
          name="totalValue"
          value={totalValue ? Number(totalValue.toFixed(2)) : ''}
          textFieldType="number"
          width={4}
          disabled
          handleIpChange={() => { }}
        />
      )}

      <InputFields
        label="Total M3"
        name="total_M3"
        value={totalM3 ? Number(totalM3.toFixed(2)) : ''}
        textFieldType="number"
        width={4}
        disabled
        handleIpChange={() => { }}
      />

      <InputFields
        label="Total M3 /Hr"
        name="total_M3PerHr"
        required={true}
        value={curForwardingData['total_M3PerHr']}
        textFieldType={'number'}
        multiline={true}
        width={4}
        handleIpChange={handleChangeForwardingData}
      />

      <Grid item xs={12} sm={12} md={6}>
        <DropzoneUpload label="File Upload" onFileSelect={handleFileChange('files')} multiple={true} />

        <Box
          sx={{
            display: 'flex',
            overflowX: 'auto',
            gap: 1,
            py: 1,
            px: 0.5,
            alignItems: 'center',
            minHeight: 60,
          }}>
          {isLoading ? (
            <Box sx={{ display: 'flex' }}>
              <CircularProgress size={22} />
              <Typography style={{ marginLeft: 8 }}>Fetching Docs ...</Typography>
            </Box>
          ) : files && files?.length > 0 ? (
            files.map((file, index) => (
              <Tooltip title={file.docName} key={index}>
                <div>
                  <Chip
                    label={file?.documentName?.length > 20 ? file.documentName.slice(0, 18) + '…' : file.documentName}
                    color="success"
                    sx={{ fontSize: '0.7rem', height: '24px', px: 1 }}
                    onDelete={() => handleDeleteFiles(file)}
                    onClick={() => viewFile(file)}
                  />
                </div>
              </Tooltip>
            ))
          ) : (
            <Typography>No files uploaded.</Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Overnight Stay
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'overnightStay'}
          value={curForwardingData['overnightStay'] || null}
          options={yesNoOption}
          onChange={(event, newValue) => handleChangeForwardingData('overnightStay', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>
      <InputFields
        label="Full Name (Accommodation)"
        name="fullNameAccommodation"
        required={curForwardingData['overnightStay'] == 'Yes'}
        value={curForwardingData['fullNameAccommodation']}
        textFieldType={'text'}
        multiline={true}
        width={8}
        handleIpChange={handleChangeForwardingData}
        disabled={curForwardingData['overnightStay'] != 'Yes'}
      />
      <InputFields
        label="Additional Information"
        name="additionalInformation"
        required={false}
        value={curForwardingData['additionalInformation']}
        textFieldType={'text'}
        multiline={true}
        width={12}
        handleIpChange={handleChangeForwardingData}
      />
    </Grid>
  );
};

export default HFDailyForwardingCloseForm;
